<template>
  <b-container fluid>
    <b-row class="page-heading">
      <b-col>
        <h1>Affectation département → entrepôt</h1>
        <p class="text-muted">
          Entrepôt de rattachement par défaut selon le département de l'adresse de livraison
          (affectation automatique des préparations en mode livraison et retours Chronopost).
        </p>
      </b-col>
    </b-row>

    <div v-if="isBusy" class="loader"></div>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content">
            <b-row class="mb-3" align-v="end">
              <b-col md="4">
                <label>Filtrer par entrepôt</label>
                <b-form-select v-model="filterWarehouse" :options="filterOptions"></b-form-select>
              </b-col>
              <b-col>
                <span class="text-muted">{{ filteredDepartments.length }} / {{ departments.length }} département(s)</span>
              </b-col>
            </b-row>
            <b-table hover :items="filteredDepartments" :fields="fields" show-empty empty-text="Aucun département pour ce filtre.">
              <template slot="warehouse" slot-scope="data">
                {{ data.item.warehouse ? data.item.warehouse.name : "— Aucun —" }}
              </template>
              <template slot="actions" slot-scope="data">
                <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover title="Éditer" @click="openEdit(data.item)">
                  <i class="far fa-pencil"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal id="department_edit_modal" hide-footer centered no-close-on-backdrop>
      <template slot="modal-title">
        <i class="far fa-pencil"></i>
        Département {{ editing.code }} — {{ editing.name }}
      </template>
      <b-form>
        <b-form-group label="Entrepôt" label-for="edit_warehouse_id">
          <b-form-select id="edit_warehouse_id" v-model="editing.warehouse_id" :options="warehouseOptions"></b-form-select>
        </b-form-group>
        <div class="form-submit">
          <b-button variant="outline-primary" @click.prevent="saveEdit()">Enregistrer</b-button>
        </div>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "DepartmentWarehouseList",
  data() {
    return {
      isBusy: false,
      departments: [],
      filterWarehouse: "all",
      fields: [
        { key: "code", label: "Dépt" },
        { key: "name", label: "Département" },
        { key: "warehouse", label: "Entrepôt" },
        { key: "actions", label: "Actions" },
      ],
      editing: { id: null, code: null, name: null, warehouse_id: null },
    };
  },
  computed: {
    warehouseOptions() {
      const options = [{ value: null, text: "— Aucun —" }];
      (this.$store.getters["warehouse/getAll"] || []).forEach((w) => {
        options.push({ value: w.id, text: w.internal_code + " - " + w.name });
      });
      return options;
    },
    filterOptions() {
      const options = [
        { value: "all", text: "Tous les entrepôts" },
        { value: "none", text: "Non affectés" },
      ];
      (this.$store.getters["warehouse/getAll"] || []).forEach((w) => {
        options.push({ value: w.id, text: w.internal_code + " - " + w.name });
      });
      return options;
    },
    filteredDepartments() {
      if (this.filterWarehouse === "all") return this.departments;
      if (this.filterWarehouse === "none") return this.departments.filter((d) => !d.warehouse);
      return this.departments.filter((d) => d.warehouse && d.warehouse.id === this.filterWarehouse);
    },
  },
  mounted() {
    this.isBusy = true;
    Promise.all([
      this.$http.get(process.env.BACK_API_URL + "department-warehouse"),
      this.$store.dispatch("warehouse/getAll", true),
    ])
      .then(([response]) => {
        this.departments = response.data.departments || [];
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      });
  },
  methods: {
    openEdit(department) {
      this.editing = {
        id: department.id,
        code: department.code,
        name: department.name,
        warehouse_id: department.warehouse ? department.warehouse.id : null,
      };
      this.$root.$emit("bv::show::modal", "department_edit_modal");
    },
    saveEdit() {
      const e = this.editing;
      const params = {
        warehouse_id: e.warehouse_id || "",
      };
      this.$http
        .patch(process.env.BACK_API_URL + "department-warehouse/" + e.id, null, { params })
        .then(() => {
          const dept = this.departments.find((d) => d.id === e.id);
          if (dept) {
            const w = (this.$store.getters["warehouse/getAll"] || []).find((w) => w.id === e.warehouse_id);
            dept.warehouse = e.warehouse_id ? { id: e.warehouse_id, name: w ? w.name : "" } : null;
          }
          this.$root.$emit("bv::hide::modal", "department_edit_modal");
          this.$toastr.success("Département " + e.code + " mis à jour.");
        })
        .catch(() => {
          this.$toastr.error("Échec de la mise à jour du département " + e.code + ".");
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DepartmentWarehouse/DepartmentWarehouseList.vue